module.exports = __webpack_public_path__ + "img/banner01.f0031817.png";